import { render, staticRenderFns } from "./DeceasedCategorized.vue?vue&type=template&id=312391e4&"
import script from "./DeceasedCategorized.vue?vue&type=script&lang=js&"
export * from "./DeceasedCategorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports